import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { StripeService } from "../../../services/stripe.service";
import { IPaymentMethod } from "../../../models/Stripe";

export const useGetStripePaymentMethodsQuery = () => {
  return useQuery<{ paymentMethods: IPaymentMethod[] }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_STRIPE_PAYMENT_METHODS],
    queryFn: async () => StripeService.getPaymentMethods().then((res) => res.data),
  });
};
